import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  where,
} from "firebase/firestore";
import { db } from "../config/firebase";

const sanitizeNumber = (value) => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value.replace(/\s/g, ""));
    return Number.isFinite(parsed) ? parsed : 0;
  }
  return 0;
};

const normalizeContract = (docSnap) => ({
  id: docSnap.id,
  ...docSnap.data(),
});

export const contractService = {
  async createContract(leadId, data, userId) {
    const amount = sanitizeNumber(data.amount);
    if (amount <= 0) {
      throw new Error("Le montant du contrat doit être supérieur à 0");
    }

    const leadRef = doc(db, "leads", leadId);
    const leadSnap = await getDoc(leadRef);
    if (!leadSnap.exists()) {
      throw new Error("Prospect introuvable");
    }

    const leadData = leadSnap.data();
    const assignedToUserId = leadData.assignedToUserId || userId;
    const signedDate = data.signedAt ? new Date(data.signedAt) : new Date();

    const payload = {
      leadId,
      userId,
      assignedToUserId,
      amount,
      currency: data.currency || leadData.revenueCurrency || "XOF",
      signedAt: signedDate,
      notes: (data.notes || "").trim(),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };

    const docRef = await addDoc(collection(db, "contracts"), payload);
    return { id: docRef.id, ...payload };
  },

  async getContractsByLead(leadId) {
    const contractsRef = collection(db, "contracts");
    const q = query(
      contractsRef,
      where("leadId", "==", leadId),
      orderBy("signedAt", "desc")
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(normalizeContract);
  },

  async getContractsByUser(userId) {
    const contractsRef = collection(db, "contracts");
    const q = query(contractsRef, where("assignedToUserId", "==", userId));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(normalizeContract);
  },

  async getAllContracts() {
    const contractsRef = collection(db, "contracts");
    const snapshot = await getDocs(contractsRef);
    return snapshot.docs.map(normalizeContract);
  },
};
